class PotomacService {
  constructor(isProd, appId) {
    this.appId = appId.toString();
    this.name = 'potomac';

    window.sp('newTracker', 'capone', isProd ? 'potomac-clickstream.capitalone.com' : 'potomac-stage.capitalone.com', {
      appId: 'coaf_refi',
      discoverRootDomain: true,
      platform: 'web',
      post: true,
      contexts: {
        webPage: true,
        performanceTiming: true,
      },
    });
  }

  get appId() {
    return this._appId;
  }

  set appId(appId) {
    this._appId = appId.toString();
  }

  trackPageview(ev) {
    window.sp('trackPageView', ev.detail.pagename, [
      {
        schema: 'iglu:com.capitalone.snowplow/application/jsonschema/1-0-0',
        data: {
          applicationId: this.appId,
        },
      },
    ]);
  }

  trackClick(elem) {
    const elementName = elem.getAttribute('data-track');
    window.sp('trackSelfDescribingEvent', {
      schema: 'iglu:com.capitalone.snowplow/ui_interaction/jsonschema/1-0-0',
      data: {
        elementName,
        value: '',
        action: 'click',
        elementType: this._elemMap(elem),
      },
    });
  }

  trackEvent(ev) {
    window.sp('trackSelfDescribingEvent', {
      schema: 'iglu:com.capitalone.snowplow/ui_interaction/jsonschema/1-0-0',
      data: {
        elementName: ev.detail.name,
        value: ev.detail.value.toString() || '',
        action: ev.detail.action || 'msg',
        elementType: this._elemMap(ev.detail.elementType) || 'message',
      },
    });
  }

  trackOfferCard(ev) {
    window.sp('trackSelfDescribingEvent', {
      schema: 'iglu:com.capitalone.snowplow/application/jsonschema/1-0-3',
      data: {
        applicationId: this.appId,
        productName: 'Auto Refinance',
        lob: 'Auto Refinance',
        monthlyPayment: Number(ev.detail.offerPayment),
        apr: !ev.detail.cmputdAPR || ev.detail.cmputdAPR === 0 ? Number(ev.detail.offerApr) : Number(ev.detail.cmputdAPR),
        termLength: Number(ev.detail.term),
        monthlySavings: Number(ev.detail.savings.monthlySavings),
        lifetimeSavings: Number(ev.detail.savings.lifetimeSavings),
      },
    });
  }

  _elemMap(elem) {
    if (elem.nodeName) {
      switch (elem.nodeName.toLowerCase()) {
        case 'a':
        case 'span':
          return 'link';
        case 'select':
          return 'dropdown';
        case 'input':
          return this._inputMap(elem.getAttribute('type'));
        case 'refi-common-tooltip':
          return 'tooltiplink';
        case 'div':
          return 'button';
        case 'gwc-accordion':
          return 'drawer';
        case 'text':
          return 'message';
        default:
          return elem.nodeName.toLowerCase();
      }
    }
    return '';
  }

  _inputMap(inputType) {
    switch (inputType.toLowerCase()) {
      case 'checkbox':
        return 'checkbox';
      case 'radio':
        return 'radiobutton';
      case 'submit':
        return 'button';
      default:
        return 'textfield';
    }
  }
}

export { PotomacService };
